export default {
  instance: {
    '0': {
      color: 'gray',
      text: 'unpaid',
    },
    '1': {
      color: 'volcano',
      text: 'paid',
    },
    '10': {
      color: 'green',
      text: 'running',
    },
    '101': {
      color: 'geekblue',
      text: 'terminate',
    },
  },
  instance_vm: {
    '0': {
      color: 'orange',
      text: 'pending',
    },
    '1': {
      color: 'volcano',
      text: 'register',
    },
    '5': {
      color: 'green',
      text: 'creating',
    },
    '10': {
      color: 'cyan',
      text: 'running',
    },
    '20': {
      color: 'blue',
      text: 'pause',
    },
    '30': {
      color: 'geekblue',
      text: 'stop',
    },
    '40': {
      color: 'geekblue',
      text: 'deleted',
    },
  },
  machine: {
    '0': {
      color: 'blue',
      text: 'created',
    },
    '5': {
      color: 'purple',
      text: 'connected',
    },
    '10': {
      color: 'green',
      text: 'publish',
    },
    '11': {
      color: 'red',
      text: 'hidden',
    },

  },
  order: {
    '0': {
      color: 'gray',
      text: 'unpaid',
    },
    '1': {
      color: 'volcano',
      text: 'paid',
    },
    '10': {
      color: 'green',
      text: 'success',
    },
    '101': {
      color: 'geekblue',
      text: 'close',
    },
  },
  recharge: {
    '0': {
      color: 'gray',
      text: 'unpaid',
    },
    '1': {
      color: 'green',
      text: 'paid',
    },
  },
  user: {
    '0': {
      color: 'volcano',
      text: 'disabled',
    },
    '1': {
      color: 'green',
      text: 'active',
    },
  },
  user_cert: {
    '0': {
      color: 'gray',
      text: 'normal',
    },
    '1': {
      color: 'cyan',
      text: 'commit',
    },
    '2': {
      color: 'red',
      text: 'deny',
    },
    '3': {
      color: 'green',
      text: 'passed',
    },
    '4': {
      color: 'green',
      text: 'passed',
    },
  },
}
